import React from "react";
import { useTranslation } from "react-i18next";
import { Globe, Check } from "lucide-react";
import { LANGUAGES } from "@/i18n";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function LanguageSwitcher({ variant = "ghost" }) {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];
  const active = LANGUAGES.find((l) => l.code === current) || LANGUAGES[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher"
          className={`inline-flex items-center gap-1.5 h-9 px-2.5 rounded-lg text-sm font-medium transition-colors ${
            variant === "outline"
              ? "border border-border bg-card text-foreground hover:bg-secondary"
              : "text-muted-foreground hover:text-foreground hover:bg-secondary"
          }`}
        >
          <Globe size={16} strokeWidth={1.75} />
          <span className="uppercase text-xs tracking-wide">{active.code}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => i18n.changeLanguage(l.code)}
            className="cursor-pointer justify-between"
          >
            <span>{l.label}</span>
            {l.code === active.code && <Check size={15} className="text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
